/**
 * 分红事件 — 调度说明；账本见「分红记录」。
 */
import { Alert } from 'antd';
import { Link } from 'react-router-dom';

export function ForkEventPage() {
  return (
    <div>
      <h2 style={{ marginTop: 0 }}>分红事件</h2>
      <Alert
        type="info"
        showIcon
        message="事件触发与调度"
        description="分红类入账由定时任务与配置项（如 uo_config 中的 fork.enabled）驱动。此处不包含手动「触发」按钮；运维可在数据库或后续任务面板中调整。"
        style={{ marginBottom: 16 }}
      />
      <p>
        查看已产生的分红类动账：{' '}
        <Link to="/platform/fork/log">分红记录（账本）</Link>
      </p>
    </div>
  );
}
